import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../CSS/NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Page Not Found</h2>
        <p className="not-found-message">
          The page you are looking for does not exist or you do not have permission to access it.
        </p>
        <button 
          onClick={handleGoHome}
          className="not-found-button"
        >
          Go to Home Page
        </button>
      </div>
    </div>
  );
};

export default NotFound;



